// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricPromptDataExpectedRubric } from './rubricPromptDataExpectedRubric';
import type { RubricPromptDataQualityScore } from './rubricPromptDataQualityScore';

/**
 * Complete data structure used for rubric generation prompts - optimized for CSV export
 */
export interface RubricPromptData {
  task_id: string;
  tenant_id: string;
  task_title: string;
  task_description: string;
  task_objectives: string;
  resource_digests: string;
  eval_dimensions: string;
  performance_levels: string;
  module_title: string;
  module_description: string;
  created_at: string;
  expected_rubric?: RubricPromptDataExpectedRubric;
  quality_score?: RubricPromptDataQualityScore;
  curator_notes?: string;
}
